<script setup lang="ts">
/** Choix de l'icône d'une enveloppe : grille de 5 colonnes dans un sheet, cibles de 56 px. */
import { ref, useId } from 'vue'

import { fr } from '@/copy/fr'

import { envelopeIcons, type EnvelopeIconName } from '../icons/registry'
import Icon from './Icon.vue'
import Sheet from './Sheet.vue'

defineProps<{ label: string }>()

const model = defineModel<EnvelopeIconName>({ required: true })
const open = ref(false)
const id = useId()

const names = Object.keys(envelopeIcons) as EnvelopeIconName[]

function choose(name: EnvelopeIconName) {
  model.value = name
  open.value = false
}
</script>

<template>
  <div class="flex flex-col gap-2">
    <span :id="id" class="text-label text-ink">{{ label }}</span>
    <button
      type="button"
      :aria-labelledby="id"
      :aria-description="fr.ui.envelopeIcon[model]"
      aria-haspopup="dialog"
      class="flex size-control items-center justify-center rounded-control bg-surface text-ink transition-colors duration-80 active:bg-surface-strong"
      @click="open = true"
    >
      <Icon :name="model" :size="24" />
    </button>
  </div>

  <Sheet v-model:open="open" :title="label">
    <div class="grid grid-cols-5 gap-2" role="radiogroup" :aria-label="label">
      <button
        v-for="name in names"
        :key="name"
        type="button"
        role="radio"
        :aria-checked="name === model"
        :aria-label="fr.ui.envelopeIcon[name]"
        :class="[
          'flex aspect-square items-center justify-center rounded-control transition-colors duration-80',
          name === model
            ? 'bg-accent-soft text-accent-strong outline-2 outline-accent'
            : 'bg-surface text-ink active:bg-surface-strong',
        ]"
        @click="choose(name)"
      >
        <Icon :name="name" :size="24" />
      </button>
    </div>
  </Sheet>
</template>
